const MIN_KEYWORD_COEFFICIENT = 1;
const MAX_KEYWORD_COEFFICIENT = 10;
const KEYWORD_COEFFICIENT_SPAN = MAX_KEYWORD_COEFFICIENT - MIN_KEYWORD_COEFFICIENT;

/** Maps the absolute 1..10 keyword coefficient contract onto a stable 0..1 CSS weight. */
export function keywordWeight(coefficient: unknown): number {
	const numeric = Number(coefficient);
	const bounded = Math.min(MAX_KEYWORD_COEFFICIENT, Math.max(MIN_KEYWORD_COEFFICIENT, Number.isFinite(numeric) ? numeric : MIN_KEYWORD_COEFFICIENT));
	return (bounded - MIN_KEYWORD_COEFFICIENT) / KEYWORD_COEFFICIENT_SPAN;
}

export function keywordWeightCssValue(coefficient: unknown): string {
	return keywordWeight(coefficient).toFixed(3);
}

/** Converts a relative 0..1 generation score into the canonical integer coefficient scale. */
export function keywordCoefficientFromNormalizedWeight(weight: unknown): number {
	const numeric = Number(weight);
	const bounded = Math.min(1, Math.max(0, Number.isFinite(numeric) ? numeric : 0));
	return Math.max(MIN_KEYWORD_COEFFICIENT, Math.min(MAX_KEYWORD_COEFFICIENT, Math.round(bounded * MAX_KEYWORD_COEFFICIENT)));
}

/** Gives synthetic fallback keywords a useful descending rank on the canonical 1..10 scale. */
export function fallbackKeywordCoefficient(index: number): number {
	return Math.max(MIN_KEYWORD_COEFFICIENT, MAX_KEYWORD_COEFFICIENT - Math.max(0, Math.floor(index)));
}
